import { default as index8oGxoC2YjxMeta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/index.vue?macro=true";
import { default as infoTRfFH8ae3dMeta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/info.vue?macro=true";
import { default as _91challengeId_93wOkoLtuZK5Meta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/static/promoter/[contentVersionId]/[challengeId].vue?macro=true";
import { default as registrationz9cP2a9QoqMeta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/static/registration.vue?macro=true";
import { default as _91batchId_937Z1ckFEfTqMeta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/static/results/[batchId].vue?macro=true";
import { default as _91groupId_93djyO0iGS5sMeta } from "/home/runner/work/wdd/wdd/frontend/wdd/pages/static/video/[groupId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/info.vue").then(m => m.default || m)
  },
  {
    name: "static-promoter-contentVersionId-challengeId",
    path: "/static/promoter/:contentVersionId()/:challengeId()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/static/promoter/[contentVersionId]/[challengeId].vue").then(m => m.default || m)
  },
  {
    name: "static-registration",
    path: "/static/registration",
    meta: registrationz9cP2a9QoqMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/static/registration.vue").then(m => m.default || m)
  },
  {
    name: "static-results-batchId",
    path: "/static/results/:batchId()",
    meta: _91batchId_937Z1ckFEfTqMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/static/results/[batchId].vue").then(m => m.default || m)
  },
  {
    name: "static-video-groupId",
    path: "/static/video/:groupId()",
    meta: _91groupId_93djyO0iGS5sMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/wdd/pages/static/video/[groupId].vue").then(m => m.default || m)
  }
]